import { Layout } from "@/components/layout/Layout";
import { usePageMeta } from "@/hooks/use-page-meta";
import { ContactForm } from "@/components/contact-form";
import { site } from "@/data/site";
import { Mail, MapPin } from "lucide-react";


export default function Contact() {
  usePageMeta("Contact", "Get in touch with Travis Johnson for business partnerships, technology projects, and operational challenges.");

  const contactReasons = [
    "Business partnerships",
    "Technology and product projects",
    "Ecommerce and telehealth systems",
    "Advisory opportunities",
    "Media and creative projects",
    "General introductions"
  ];

  return (
    <Layout>
      <div className="container mx-auto px-6 py-12 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 max-w-6xl mx-auto">
          
          <div className="lg:col-span-5 space-y-12">
            <div>
              <h1 className="text-4xl md:text-5xl font-serif font-medium tracking-tight mb-6">
                Have something complicated?
              </h1>
              <p className="text-xl text-muted-foreground leading-relaxed">
                I'm always interested in meeting good people, hearing about unusual projects, and helping solve problems that sit somewhere between technology and business.
              </p>
            </div>

            <div>
              <h2 className="text-sm font-semibold uppercase tracking-wider text-muted-foreground mb-4 border-b border-border pb-2">
                What I typically discuss
              </h2>
              <ul className="space-y-3">
                {contactReasons.map((reason, i) => (
                  <li key={i} className="flex items-start">
                    <span className="w-1.5 h-1.5 rounded-full bg-accent mt-2 mr-3 shrink-0" />
                    <span className="text-foreground/90">{reason}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="space-y-6 pt-4 border-t border-border">
              <a href={`mailto:${site.email}`} className="flex items-center text-muted-foreground hover:text-foreground transition-colors group">
                <div className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center mr-4 group-hover:bg-accent group-hover:text-accent-foreground transition-colors">
                  <Mail className="w-4 h-4" />
                </div>
                <span className="font-medium">{site.email}</span>
              </a>
              <div className="flex items-center text-muted-foreground">
                <div className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center mr-4">
                  <MapPin className="w-4 h-4" />
                </div>
                <span className="font-medium">{site.location}</span>
              </div>
              <a href={site.linkedin} target="_blank" rel="noopener noreferrer" className="flex items-center text-muted-foreground hover:text-foreground transition-colors group">
                <div className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center mr-4 group-hover:bg-[#0077b5] group-hover:text-white transition-colors">
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                </div>
                <span className="font-medium">Connect on LinkedIn</span>
              </a>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="bg-card border border-border p-8 md:p-10 rounded-3xl shadow-sm">
              <ContactForm />
            </div>
          </div>
          
        </div>
      </div>
    </Layout>
  );
}
